import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

export interface NavLinkItem {
  href: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

interface NavLinkProps {
  item: NavLinkItem;
  isActive: boolean;
}

export function NavLink({ item, isActive }: NavLinkProps) {
  const Icon = item.icon;
  return (
    <Link
      to={item.href}
      className={cn(
        'flex items-center gap-3 px-3 py-2.5 rounded-[var(--radius)] text-sm font-medium transition-colors',
        isActive
          ? 'bg-accent text-accent-foreground'
          : 'text-foreground hover:bg-surface-secondary',
      )}
    >
      <Icon className="w-4 h-4" />
      {item.label}
    </Link>
  );
}
